import { FormikValues } from 'formik'

export interface UpdateIssuerComplianceRuleValues extends FormikValues {
  id: number
  rating: string
  ratingType: string
  maxLimit: number
}

export const updateIssuerComplianceRuleValues: UpdateIssuerComplianceRuleValues = {
  id: 0,
  rating: null,
  ratingType: null,
  maxLimit: 0,
}
